export enum accountTypes {
    FETCH_SETTINGS_REQUEST = 'FETCH_SETTINGS_REQUEST',
    EDIT_SETTINGS_REQUEST = 'EDIT_SETTINGS_REQUEST',
    SET_SETTINGS = 'SET_SETTINGS',
}
